import React, { useCallback } from "react";
import { makeDelete } from "@culturehq/client";
import { Button } from "@culturehq/components";

import { Trans } from "app/utils";

import { TimeDiff } from "components/common/Time";
import ChqModalConfirmDelete from "components/common/ChqModalConfirmDelete";
import { ExternalMapper, ExternalMapperValue } from "chq";
import MapperModal from "./MapperModal";

interface MapperRowProps {
  externalMapper: ExternalMapper;
  externalMapperValue: ExternalMapperValue;
  onUpdate: (updatedMapper: ExternalMapperValue) => void;
  onDelete: (deletedMapper: ExternalMapperValue) => void;
}

const MapperRow: React.FC<MapperRowProps> = ({
  externalMapper, externalMapperValue, onUpdate, onDelete
}) => {
  const onConfirmDelete = useCallback(async () => {
    await makeDelete(`/external_mapper_values/${externalMapperValue.id}`);
    onDelete(externalMapperValue);
  }, [externalMapperValue, onDelete]);

  return (
    <tr>
      <td>{externalMapperValue.value}</td>
      <td>
        <TimeDiff time={externalMapperValue.createdAt || ""} />
      </td>
      <td>
        <TimeDiff time={externalMapperValue.updatedAt || ""} />
      </td>
      <td className="Actions-column">
        <MapperModal
          externalMapper={externalMapper}
          externalMapperValue={externalMapperValue}
          onUpdate={onUpdate}
        >
          {onTrigger => (
            <Button icon="edit-outlined" onClick={onTrigger} inverted aria-label="edit" />
          )}
        </MapperModal>
        <ChqModalConfirmDelete
          onAccept={onConfirmDelete}
          trigger={(onTrigger: any) => (
            <Button icon="trash-a-outlined" onClick={onTrigger} inverted aria-label="Delete" />
          )}
        >
          <Trans>Are you sure you would like to delete this {externalMapper.label}?</Trans>
        </ChqModalConfirmDelete>
      </td>
    </tr>
  );
};

export default MapperRow;
